import { setBrowserEnv } from "@blue-ocean-robotics/seto_utils";
import { StrictMode } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

setBrowserEnv();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
  // document.body
);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
